<template>
  <div>
    <vs-card>
      <b-row align-h="start">
        <!--
        <b-col cols="3" md="auto" style="padding-right: 2px; min-width: 200px">
          <b-form-datepicker
            id="start"
            v-model="startDate"
            size="md"
            :locale="locale"
            class="mb-2"
            today-variant="danger"
            placeholder="-"
            :start-weekday="weekday"
            :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
            }"
          />
        </b-col>
        <b-col cols="3" md="auto" style="padding-right: 2px; min-width: 200px">
          <b-form-datepicker
            id="end"
            v-model="endDate"
            size="md"
            :locale="locale"
            class="mb-2"
            today-variant="danger"
            placeholder="-"
            :start-weekday="weekday"
            :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
            }"
          />
        </b-col>-->
        <b-col cols="3" md="auto" style="padding-right: 2px">
          <b-button
            class="bg-primary"
            style="border-color: white"
            v-on:click="filterCorridor()"
          >
            <Icon
              icon="ph:list-fill"
              style="margin-right: 5px"
              width="20"
              height="20"
            />{{ $t("List") }}
          </b-button>
        </b-col>
      </b-row>
    </vs-card>
    <vs-card>
      <ag-grid-vue
        ref="agGridTable"
        class="scroll-to-ag-grid-table ag-theme-alpine w-100 my-4 ag-grid-table"
        :columnDefs="columns"
        :defaultColDef="defaultColDef"
        :rowData="processList"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :pagination="true"
        @grid-ready="onGridReady"
        :suppressCopyRowsToClipboard="true"
        :localeText="localeText"
        :suppressRowClickSelection="true"
        @first-data-rendered="onFirstDataRendered"
      >
      </ag-grid-vue>
    </vs-card>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import { Icon } from "@iconify/vue2";
import i18nData from "../../i18n/i18nData";
import detailBtnCellRenderer from "../CellRenderers/detailBtnCellRenderer.vue";
import moment from "moment";

export default {
  data() {
    return {
      locale: "de",
      weekday: 1,
      addNewInfoDataSidebar: false,
      isPromptActiveEmployeeLocal: false,
      addNewActSidebar: false,
      infoData: [],
      endDate: "",
      startDate: "",
      processList: [],
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
      },
      columns: [],
    };
  },
  components: {
    detailBtnCellRenderer,
    AgGridVue,
    Icon,
  },
  methods: {
    parseDate(params) {
      return moment(String(params)).format("YYYY-MM-DD");
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    getCorridorColumnList() {
      this.columns = [];
      if (this.processList.length > 0) {
        let columnList = Object.keys(this.processList[0]);

        columnList.forEach((val, index) => {
          if (val == "CompanyName" || val == "Barcode" || val == "Description") {
            this.columns.push({
              pinned: "left",
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
            });
          } else if (val.toString().includes("Date") == true)
            this.columnsProcess.push({
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
              valueFormatter: (params) => this.parseDate(params.data[val]),
              editable: true,
            });
          else if (
            val.toString().includes("Id") == false &&
            val.toString().includes("TrasnType") == false
          ) {
            this.columns.push({
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
            });
          }
        });
      }
    },

    filterCorridor() {
      const vs = this.$vs;

      this.$store
        .dispatch("storehouse/listCorridor")
        .then((response) => {
          if (response.success == true) {
            try {
            } catch (error) {
              console.log(error);
            }
          } else
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
        })
        .catch((error) => {
          console.log(error);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      var defaultSortModel = [{ colId: "CompanyName", sort: "asc", sortIndex: 0 }];
      params.columnApi.applyColumnState({ state: defaultSortModel });
      this.gridApi.refreshCells(params);
    },
  },
  computed: {
    corridor: {
      get() {
        return this.$store.state.storehouse.Corridor;
      },
      set(val) {
        if (!val) {
        }
      },
    },

    localeText() {
      return i18nData[this.$i18n.locale];
    },
  },
  mounted() {
    this.$root.$on("employeeDetail", (data) => {
      this.infoData = data;
      this.employeeDetail(data);
    });
  },
  beforeDestroy() {
    this.$root.$off("employeeDetail");
  },
  watch: {
    corridor(val) {
      if (val.length > 0) {
        this.processList = val;
        this.getCorridorColumnList();
      }
      return val;
    },
  },
  created() {
    this.filterCorridor();
  },
};
</script>
<style lang="scss" scoped>
.scroll-to-ag-grid-table {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 190px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
